"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const TabEmptyContent_1 = require("./TabEmptyContent");
const TabContent = ({ children, title, isEmpty, emptyLabel }) => {
    if (emptyLabel && isEmpty) /*TODO is it good?*/
        return ((0, jsx_runtime_1.jsx)(TabEmptyContent_1.TabEmptyContent, { text: emptyLabel }));
    return ((0, jsx_runtime_1.jsxs)("div", { className: "py-4 px-1 px-md-3", children: [title && ((0, jsx_runtime_1.jsx)("h3", { className: "fw-bold", children: title })), children] }));
};
exports.TabContent = TabContent;
